const { config } = require('../../config.js');
const getPredictions = async string => {

    let predictions = (await (await fetch(config.api + 'getPredictions', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            string,
        }),
    })).json()).predictions;

    return predictions;

}
export default getPredictions;

